import React from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { inject, observer } from "mobx-react";
import withCustomStyles from "./StickyCartBarPart.style";
import gtmService from "../services/GTMService";
import { formatItemCount, formatPrice } from "../utils/FormatUtils";
import { STANDALONE_PAGES } from "../constatns/AppConstants";

// Pages where the floating "View cart" pill is not shown: flows with their own
// bottom action, account pages and one-off utility pages.
const HIDDEN_PREFIXES = [
  ...STANDALONE_PAGES,
  "/myorders",
  "/profile",
  "/wallet",
  "/membership",
  "/add-card",
  "/saved-locations",
  "/add-address",
  "/edit-address",
  "/order/",
  "/redirect",
  "/unsubscribe",
  // content / legal pages
  "/terms",
  "/privacy",
  "/return-and-refund-policy",
  "/faqs",
  "/about-us",
  "/mobile-app"
];

export const isCartBarHidden = pathname =>
  HIDDEN_PREFIXES.some(prefix => pathname.startsWith(prefix));

// Black pill fixed to the bottom centre: "N items · View cart · Rs X".
@inject(["orderStore"])
@observer
class StickyCartBarPart extends React.Component {
  handleClick = () => {
    gtmService.event(
      "User",
      "Sticky_cart_bar_clicked",
      this.props.location.pathname
    );
  };

  render() {
    const {
      classes,
      orderStore,
      location: { pathname }
    } = this.props;
    const count = orderStore.all.size;

    if (!count || isCartBarHidden(pathname)) {
      return null;
    }

    return (
      <div className={classes.wrap}>
        <Link to="/cart" className={classes.bar} onClick={this.handleClick}>
          <span className={classes.count} aria-live="polite">
            {formatItemCount(count)}
          </span>
          <span className={classes.cta}>
            View cart · {formatPrice(orderStore.subTotal)}
          </span>
        </Link>
      </div>
    );
  }
}

export default withRouter(withCustomStyles(StickyCartBarPart));
